var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChekinImagoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 200,
    viewBox: "0 0 500 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-new-chekin-landscape",
    transform: "translate(-2847 15589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3204",
    "data-name": "Rectangle 3204",
    width: 500,
    height: 200,
    transform: "translate(2847 -15589)",
    fill: "#19194b",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(2885.147 -15559.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12974",
    "data-name": "Group 12974",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13142",
    "data-name": "Group 13142",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26218",
    "data-name": "Path 26218",
    d: "M-234.9-58.382c0,28.247,19.45,50.007,49.57,50.007a53.74,53.74,0,0,0,33.9-11.893c2.7-2.3,2.836-5.136.81-7.839l-2.7-3.649c-2.161-3.109-4.862-3.109-7.834-.946-4.457,3.244-12.7,8.38-23.5,8.38-20.665,0-32.281-16.354-32.281-34.329,0-17.705,11.211-32.977,32.146-32.977a39.9,39.9,0,0,1,21.611,6.758c3.242,2.027,5.808,1.757,7.7-1.352l2.431-3.919c1.891-2.973,1.756-5.676-1.081-7.839a53.483,53.483,0,0,0-31.336-9.6C-214.5-107.578-234.9-86.224-234.9-58.382ZM-136.7-15.674c0,3.784,2.026,5.676,5.673,5.676h5.808q5.673,0,5.673-5.676V-42.029c0-13.11,7.834-22.841,19.855-22.841,8.644,0,10.805,5.676,10.805,14.056v35.14q0,5.676,5.673,5.676h5.808c3.647,0,5.673-1.892,5.673-5.676V-54.328c0-18.246-8.779-26.22-24.042-26.22-11.886,0-20.53,7.3-23.907,13.921h-.27a39.151,39.151,0,0,0,.405-5.812V-100.28c0-3.649-1.891-5.676-5.673-5.676h-5.808c-3.647,0-5.673,2.027-5.673,5.676Zm76.718-28.788c0,19.6,14.182,36.086,37.008,36.086A43.519,43.519,0,0,0,.389-15.268C3.36-17.026,3.9-19.729,2.28-22.837L.659-25.54C-1.1-28.649-3.528-29.054-6.9-27.432a28.461,28.461,0,0,1-14.857,4.46c-10.4,0-19.585-6.487-20.665-18.921H-.422a5.971,5.971,0,0,0,5.943-5.812C5.521-66.627-5.419-80.547-25-80.547-45.669-80.547-59.986-65.681-59.986-44.462ZM-42.022-52.3c1.621-9.19,7.834-15.272,16.613-15.272,7.834,0,13.642,5.676,13.912,15.272Zm59.97,36.626C17.948-11.89,19.974-10,23.62-10h5.808Q35.1-10,35.1-15.674V-40.137h8.914l16.073,26.22A6.849,6.849,0,0,0,66.707-10H74c4.592,0,6.078-2.838,3.782-6.758L57.522-47.84v-.27L74.676-72.168c2.566-3.649,1.08-6.758-3.512-6.758H64.681a7.055,7.055,0,0,0-6.753,3.784L43.61-54.6H35.1V-100.28c0-3.649-1.891-5.676-5.673-5.676H23.62c-3.647,0-5.673,2.027-5.673,5.676Zm71.991,0c0,3.784,1.891,5.676,5.538,5.676h5.943c3.647,0,5.538-1.892,5.538-5.676V-73.249c0-3.649-1.891-5.676-5.538-5.676H95.476c-3.647,0-5.538,2.027-5.538,5.676Zm34.037,0c0,3.784,1.891,5.676,5.538,5.676h5.943c3.647,0,5.538-1.892,5.538-5.676V-42.3c0-12.434,7.7-22.571,19.855-22.571,8.644,0,10.806,5.676,10.806,14.056v35.14c0,3.784,2.026,5.676,5.673,5.676h5.808q5.673,0,5.673-5.676V-54.328c0-18.246-8.779-26.22-24.042-26.22a26.865,26.865,0,0,0-24.447,14.6h-.27a22.051,22.051,0,0,0,.27-3.109v-4.19c0-3.649-1.891-5.676-5.538-5.676h-5.268c-3.647,0-5.538,2.027-5.538,5.676Z",
    transform: "translate(234.898 132.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(310.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12966",
    "data-name": "Group 12966",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26207",
    "data-name": "Path 26207",
    d: "M115.061,218.528a5.117,5.117,0,0,1,0,7.106L111.1,229.6a5.116,5.116,0,0,1-7.106,0L86.635,212.1a5.117,5.117,0,0,1,0-7.107l3.963-3.963a5.117,5.117,0,0,1,7.107,0Z",
    transform: "translate(-85.2 -186.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26208",
    "data-name": "Path 26208",
    d: "M195.9,126.635a5.117,5.117,0,0,1,7.106,0l3.963,3.963a5.117,5.117,0,0,1,0,7.107L176.9,167.634a5.116,5.116,0,0,1-7.107,0l-3.963-3.963a5.117,5.117,0,0,1,0-7.107Z",
    transform: "translate(-150.87 -125.2)",
    fill: "#fff"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChekinImagoWhite);
export default __webpack_public_path__ + "static/media/chekin-imago-white.e3ff210d9a4f2da9b36137ae8bd65ad6.svg";
export { ForwardRef as ReactComponent };